module.exports = __webpack_public_path__ + "static/media/S3N5.52ddc9aa.svg";